import { Input, Select } from "@ts-digital/vrc";

import React from "react";
import VaporFormItem from "../../../vapor/form";
import "./style.css";
import { VaporDatePicker } from "../../../vapor";

const FormCreateFulfilment = props => {

  const { fulfilmentData, setFulfilmentData } = props;

  const fulfilmentTypes = [{ description: "Contabili", value: "contabili" }, { description: "Fiscali", value: "fiscali" }, { description: "Gestione personale", value: "gestione personale" }];

  return <div className="fulfilment-create-form-root">
    <VaporFormItem label="Tipo adempimento"><Select placeholder={"Tipo adempimento"} value={fulfilmentData && fulfilmentData.type} options={fulfilmentTypes} onChange={(val) => setFulfilmentData({ ...fulfilmentData, type: val })} /></VaporFormItem>
    <VaporFormItem label="Data scadenza">
      <VaporDatePicker
        getPopupContainer={(trigger) => trigger.parentNode}
        value={fulfilmentData && fulfilmentData.deadline}
        onChange={(val) => setFulfilmentData({ ...fulfilmentData, deadline: val })} />
    </VaporFormItem>
    <VaporFormItem label="Nome adempimento"><Input placeholder={"Inserisci nome adempimento"} value={fulfilmentData && fulfilmentData.name} onChange={(val) => setFulfilmentData({ ...fulfilmentData, name: val })} /></VaporFormItem>
  </div>;
};

export default FormCreateFulfilment;